<template>
  <div>
    <v-row no-gutters v-if="role == 'SUPERADMIN' || permissions.includes('LD')">
      <v-col cols="12" md="6">
        <v-row no-gutters align="center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="$router.go(-1)"
                icon
                ><v-icon>mdi-reply</v-icon></v-btn
              >
            </template>
            <span>Back</span>
          </v-tooltip>
          <h3>List Member</h3>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <div class="d-flex justify-end">
          <v-btn
            class="bg_default text-capitalize rounded-lg"
            depressed
            dark
            @click="createMember"
            >+ Assign Scholar</v-btn
          >
        </div>
      </v-col>
    </v-row>
    <!--  ========================================================================= toolbar -->

    <v-card class="rounded_max mt-5" flat>
      <div class="pa-3">
        <v-card flat class="rounded-lg" color="#f6f6f6">
          <v-row no-gutters>
            <v-col cols="12" md="5">
              <div class="pa-2">
                <v-text-field
                  placeholder="Search Data"
                  solo
                  v-model="find"
                  @keyup="fetchData"
                  hide-details
                  dense
                  prepend-inner-icon="mdi-magnify"
                  flat
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="2">
              <div class="pa-2">
                <v-select
                  dense
                  hide-details
                  :items="optStatus"
                  item-text="txt"
                  item-value="val"
                  v-model="status_draft"
                  @change="fetchData()"
                  placeholder="Filter Status"
                  flat
                  solo
                ></v-select>
              </div>
            </v-col>
            <v-col cols="12" md="2">
              <div class="pa-2">
                <v-menu
                  v-model="menuLimit"
                  bottom
                  :nudge-bottom="55"
                  elevation="0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      class="text-capitalize color_txt"
                      height="38px"
                      block
                      color="#fff"
                      v-bind="attrs"
                      v-on="on"
                      ><p class="default_txt">Show : {{ limit }}</p>
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="popup_radius" outlined elevation="0">
                    <v-list>
                      <v-list-item link @click="changeLimit(10)">
                        <v-list-item-title>10</v-list-item-title>
                      </v-list-item>
                      <v-list-item link @click="changeLimit(50)">
                        <v-list-item-title>50</v-list-item-title>
                      </v-list-item>
                      <v-list-item link @click="changeLimit(100)">
                        <v-list-item-title>100</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <!--  ========================================================================= data table -->
      <div>
        <v-skeleton-loader
          type="table-tbody"
          v-if="loading"
        ></v-skeleton-loader>
        <div v-if="dataSet && !loading">
          <v-data-table
            :headers="headers"
            :items="dataSet"
            :page.sync="page"
            :items-per-page="limit"
            class="elevation-0 color_txt"
            hide-default-footer
            :single-select="false"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex">
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        fab
                        depressed
                        x-small
                        class="mr-2"
                        color="blue"
                        :to="`/list-review/facilitator/${
                          idCourse ? idCourse : 'admin'
                        }/${item.data_scholar.user_id}`"
                        dark
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>View Scholar</span>
                  </v-tooltip>
                </div>
                <div v-if="role == 'SUPERADMIN' || permissions.includes('LD')">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        v-bind="attrs"
                        v-on="on"
                        depressed
                        x-small
                        color="red"
                        dark
                        @click="deleteMember(item)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete Data</span>
                  </v-tooltip>
                </div>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-card>
    <div class="text-center pa-3" v-if="dataSet">
      <v-pagination
        v-model="page"
        color="#006341"
        @input="fetchData"
        :length="last_page"
      ></v-pagination>
    </div>
    <div class="pa-2">
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchData"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-large
        :d_large="d_large"
        @refetch="fetchData"
        @close="d_large = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitlePage from "../../../../components/atom/titlePage.vue";
import DialogSmall from "../../../dialog/dialogSmall.vue";
// import DialogMedium from "../../../dialog/dialogMedium.vue";
// import DialogLarge from "../../../dialog/dialogLarge.vue";
export default {
  name: "listMemberScholarFacilitator",
  props: ["color", "idCourse", "viewType"],
  components: {
    TitlePage,
    DialogSmall,
    // DialogMedium, DialogLarge
  },
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  data() {
    return {
      dataSet: null,
      loading: false,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      status_draft: "",
      d_create: false,
      d_large: false,
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
      menuLimit: false,
      month: "",
      find: "",
      optStatus: [
        { txt: "Active", val: 1 },
        { txt: "No Active", val: 2 },
        { txt: "All", val: "" },
      ],
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        {
          text: "No TELADAN",
          align: "start",
          value: "data_scholar.no_tf",
        },
        {
          text: "Scholar Name",
          align: "start",
          value: "data_scholar.name",
        },
        {
          text: "Email",
          align: "start",
          value: "data_scholar.email",
        },
        { text: "Actions", sortable: false, value: "actions" },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let cekPath = `course/fasilitator?page[number]=${this.page}&page[size]=${this.limit}&sort=-created_at&include=dataFasilitator,dataScholar&filter[search]=${this.find}&filter[user_id]=${this.$route.params.idFacilitator}`;

      if (this.viewType) {
        cekPath = `course/fasilitator?page[number]=${this.page}&page[size]=${this.limit}&sort=-created_at&include=dataFasilitator,dataScholar&filter[search]=${this.find}`;
      }
      let data = {
        path: cekPath,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    async fetchDataReviewScholar(item) {
      let tempData = [];
      let data = {
        path: `manage/review/fasilitator/list/review?&sort=-created_at&include=dataFasilitator,dataScholar,dataCourse&filter[scholar_id]=${item.scholar_id}`,
      };
      await this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          tempData = data.data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
      this.viewListReview(tempData, item.data_scholar.name);
    },
    createMember() {
      this.d_type = "cf_member";
      this.d_title = "Create New Data";
      this.d_create = true;
    },
    viewListReview(item, name) {
      this.inventory = item;
      this.d_type = "vf_list_review";
      this.d_title = `List Review ${name}`;
      this.d_large = true;
    },
    deleteMember(item) {
      this.d_type = "df_member";
      this.d_title = "Delete Data";
      this.d_small = true;
      item["d_width"] = "300px";
      this.inventory = item;
    },
    changeLimit(val) {
      this.limit = val;
      this.fetchData();
    },
  },
};
</script>
<style scoped>
.bluefy {
  background: #62c3f8;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px;
}
.white_dot {
  background: #fff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>
